import React, { useState, useEffect } from 'react'
import { MoContainer, MoLink, MoSpan } from '../../Mo7/mo7UI'
import { useAuth } from '../../context/AuthContext';
import { cols, icons } from '../../services/design.sevice';
import { config, useSpring, useTrail } from '@react-spring/core';
import { animated } from '@react-spring/web';
export default function DashHome() {
    const { currentUser } = useAuth()

    const [{ displayName, photoURL }, setDisplayNameAndPic] = useState({
        displayName: "",
        photoURL: "",
    })
    useEffect(() => {
        setTimeout(() => {
            setDisplayNameAndPic({
                displayName: currentUser.displayName,
                photoURL: currentUser.photoURL,
            })
        }, 2000);
    }, [currentUser.displayName, currentUser.photoURL])

    const anim_buttons = useSpring({
        from: {
            x: -100, opacity: 0
        },
        to: {

            x: 0, opacity: 1
        },
        config: config.wobbly
    })
    const anim_top = useTrail(2, {
        from: {
            y: -100, opacity: 0
        },
        to: {

            y: 0, opacity: 1
        },
        config: config.slow
    })

    return (<MoContainer >

        <MoContainer flex align="center" justify="space-between">
            <animated.div style={anim_top[0]} ><MoSpan fs_mid> Welcome <MoSpan fs_mid col={cols.green}>{displayName}</MoSpan> </MoSpan></animated.div>
            <animated.div style={anim_top[1]} ><MoContainer bg_i={photoURL} wh="3rem" eff_shdw={{ col: cols.main_purple }} border={{ col: cols.main_purple, w: "2px" }} m_r="1.5rem" m_t="1rem" b_r={{ all: "50%" }}>
            </MoContainer></animated.div>
        </MoContainer>
        {/* My stuff */}
        <MoContainer grid tem_r="1fr 1fr" tem_c="1fr 1fr" h="calc(100vh - 5rem)" pd={{ r: "1.5rem", t: "1.5rem", b: '1.5rem' }}>
            {/* Create Announcement */}
            <animated.div style={anim_buttons} > <MoContainer flex flex_dir_c pd={{ lr: "2rem", tb: "0" }}>
                <MoContainer h="5rem" flex align="center">
                    <MoLink to='/dashboard/edit-announcement/create'> <MoContainer hvr={"background-color:" + cols.mainDark_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.mainLight_1} grid place="center" wh="4rem">
                        <img width="25px" src={icons.ic_plus} alt="" />
                    </MoContainer>
                    </MoLink>
                    <MoSpan f_size="1.3rem" m_l="3rem"> Create Announcements </MoSpan>
                </MoContainer>

                <MoContainer h="5rem" flex align="center">
                    <MoLink to='/dashboard/announcements'> <MoContainer hvr={"background-color:" + cols.mainDark_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.mainLight_1} grid place="center" wh="4rem">
                        <img width="25px" src={icons.ic_list} alt="" />
                    </MoContainer>
                    </MoLink>
                    <MoSpan f_size="1.3rem" m_l="3rem"> My Announcements </MoSpan>
                </MoContainer>
            </MoContainer></animated.div>
            {/* Messages */}
            <animated.div style={anim_buttons} ><MoContainer flex flex_dir_c pd={{ lr: "2rem", tb: "0" }}>
                <MoContainer h="5rem" flex align="center">
                    <MoLink to='/dashboard/messages'> <MoContainer hvr={"background-color:" + cols.main_blue + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.green} grid place="center" wh="4rem">
                        <img width="25px" src={icons.ic_message} alt="" />
                    </MoContainer>
                    </MoLink>
                    <MoSpan f_size="1.3rem" m_l="3rem"> My Group Chats </MoSpan>
                </MoContainer>
            </MoContainer></animated.div>
            {/* Notifications */}
            <animated.div style={anim_buttons} ><MoContainer flex flex_dir_c pd={{ lr: "2rem", tb: "0" }}>
                <MoContainer h="5rem" flex align="center">
                    <MoLink to='/dashboard/notifications'> <MoContainer hvr={"background-color:" + cols.mainDark_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.main_purple} grid place="center" wh="4rem">
                        <img width="25px" src={icons.ic_bill} alt="" />
                    </MoContainer>
                    </MoLink>
                    <MoSpan f_size="1.3rem" m_l="3rem"> My Subscription Requests </MoSpan>
                </MoContainer>
            </MoContainer></animated.div>

            {/* Search */}
            <animated.div style={anim_buttons} ><MoContainer flex flex_dir_c pd={{ lr: "2rem", tb: "0" }}>
                <MoContainer h="5rem" flex align="center">
                    <MoLink to='/home'> <MoContainer hvr={"background-color:" + cols.mainLight_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.mainLight_1} grid place="center" wh="4rem">
                        <img width="25px" src={icons.ic_search} alt="" />
                    </MoContainer>
                    </MoLink>
                    <MoSpan f_size="1.3rem" m_l="3rem"> Search For Tutors </MoSpan>
                </MoContainer>
            </MoContainer></animated.div>


        </MoContainer>

    </MoContainer>
    )
}
